// 存储需要过滤的pid和vid列表
const filters = [{
  vendorId: 0x1A81,
  productId: 0x2090,
  usagePage: 0xFF01,
  usage: 0x0001
}
]

export {
  filters
}